































































































































































import Currency from '@/components/Currency.vue';
export default {
	name: 'pedidosrealizados',
	inject: ['responsive'],
	components: {
		Currency,
	},
	data() {
		return {
			start: 0,
			startp: 0,
			starta: 0,
			limit: 5,
			loading: false,
			showBtnMore: false,
			showBtnMorep: false,
			showBtnMorea: false,
		};
	},
	computed: {
		tituloResumen() {
			return this.$route.name;
		},
		activeProfile() {
			return this.$store.state.perfil.activeProfile;
		},
		entidadSelected() {
			return this.$store.state.perfil.entidadSelected;
		},
		pedidosTable() {
			return this.$store.state.pedidos.pedidosaprobados;
		},
		pedidosTablePendientes() {
			return this.$store.state.pedidos.pedidospendientes;
		},
		pedidosTableAplicados() {
			return this.$store.state.pedidos.pedidosaplicados;
		},
	},
	watch: {},
	methods: {
		refreshAllPedidos(): void {
			this.start = 0;
			this.starta = 0;
			this.starp = 0;
			this.loading = true;
			this.callAllPedidos();
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadPedidosAprobados();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadPedidosAprobados();
		},
		loadMorePendientes(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.startp = this.startp + this.limit;
			this.refresh = false;
			this.loadPedidosPendientes();
		},
		loadMorePendientesClick(): void {
			this.updateScroll();
			this.startp = this.startp + this.limit;
			this.loadPedidosPendientes();
		},
		loadMoreAplicados(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.starta = this.starta + this.limit;
			this.refresh = false;
			this.loadPedidosAplicados();
		},
		loadMoreClickAplicados(): void {
			this.updateScroll();
			this.starta = this.starta + this.limit;
			this.loadPedidosAplicados();
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		loadPedidosPendientes() {
			this.loading = true;
			this.$store
				.dispatch('loadPendientes', {
					start: this.startp,
					limit: this.limit,
				})
				.then(response => {
					if (response) {
						this.showBtnMorep = response.length < this.limit ? false : true;
						this.loading = false;
						const conta = document.querySelector('.el-main');
						if (conta) conta.scrollTop = this.scrollPosition;
					}
				});
		},
		loadPedidosAprobados() {
			this.$store
				.dispatch('loadAprobados', {
					start: this.start,
					limit: this.limit,
				})
				.then(response => {
					if (response) {
						this.showBtnMore = response.length < this.limit ? false : true;
						this.loading = false;
						const conta = document.querySelector('.el-main');
						if (conta) conta.scrollTop = this.scrollPosition;
					}
				});
		},
		loadPedidosAplicados() {
			this.$store
				.dispatch('loadAplicados', {
					start: this.starta,
					limit: this.limit,
				})
				.then(response => {
					if (response) {
						this.showBtnMorea = response.length < this.limit ? false : true;
						this.loading = false;
						const conta = document.querySelector('.el-main');
						if (conta) conta.scrollTop = this.scrollPosition;
					}
				});
		},
		downloadFile(doc): void {
			this.imprimiendo = true;
			this.$store.dispatch('downloadFileDirecto', { codcom: doc.codcom_id, codtal: doc.codtal_id, numero: doc.numero }).then(response => {
				if (response.success) {
					//window.open(`${response.host}/${response.archivo}`);
					//window.location.href = `${response.host}/${response.archivo}`;
					let url = `${response.host}/${response.archivo}`;
					if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) window.open(url, '_blank');
					else window.location.href = url;
					this.imprimiendo = false;
				} else {
					this.$message({
						message: response.msg,
						showClose: true,
						type: 'error',
						duration: 0,
					});
				}
			});
		},
		downloadFileWsp(doc, aa): void {
			console.log('entidad selected', this.entidadSelected);
			this.$store.dispatch('downloadFileDirecto', { codcom: doc.codcom_id, codtal: doc.codtal_id, numero: doc.numero }).then(response => {
				if (response.success) {
					const host = response.host;
					const comentario = `Hola, podes ver el comprobante de tu pedido en: ${host}/${response.archivo}`; // Reemplaza con el comentario que deseas compartir
					const encodedComentario = encodeURIComponent(comentario);
					const tel = this.entidadSelected.numero_celular;
					const url = tel
						? `https://api.whatsapp.com/send?phone=${tel}&text=${encodedComentario}`
						: `https://api.whatsapp.com/send?&text=${encodedComentario}`;
					//window.open(url, '_blank');
					window.location.href = url;
				} else {
					this.$message({
						message: response.msg,
						showClose: true,
						type: 'error',
						duration: 0,
					});
				}
			});
		},
		callAllPedidos(): void {
			this.loadPedidosPendientes();
			this.loadPedidosAprobados();
			this.loadPedidosAplicados();
		},
	},
	mounted() {
		this.callAllPedidos();
	},
};
